import { PackageType } from '@assetaccountant/api/models/package-type';

export const getPackageTypeDisplayName = (type?: PackageType | null) => {
  if (type === null || type === undefined) {
    return null;
  }

  switch (type) {
    case PackageType.LegacyFree:
    case PackageType.Free:
      return 'Free';

    case PackageType.BusinessLite:
      return 'Lite (Business)';
    case PackageType.LegacyBasic:
    case PackageType.BusinessBasic:
      return 'Basic (Business)';
    case PackageType.BusinessStandard:
      return 'Standard (Business)';

    case PackageType.BusinessLiteV2:
      return 'Lite';
    case PackageType.BusinessBasicV2:
      return 'Basic';
    case PackageType.BusinessStandardV2:
      return 'Standard';
    case PackageType.BusinessPremiumV2:
      return 'Premium';

    case PackageType.AccountingLite:
    case PackageType.AccountingV2Lite:
      return 'Lite (Accounting)';
    case PackageType.AccountingBasic:
    case PackageType.AccountingV2Basic:
      return 'Basic (Accounting)';
    case PackageType.AccountingStandard:
    case PackageType.AccountingV2Standard:
      return 'Standard (Accounting)';
    case PackageType.AccountingV2Premium:
      return 'Premium (Accounting)';
  }

  return null;
};
